// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional', 'supervisor_operacional']


const breadcrumb = [
  { label: 'Home',                to: 'Home' },
  { label: 'Liberações Gerência', to: 'LiberacoesGerencia' },
];

export default [
  {
    path: '/gerencia/liberacoes',
    name: 'LiberacoesGerencia',
    component: () => import('@/views/Ocorrencias/LiberacaoGerencia/LiberacaoGerenciaListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Liberações de Gerência',
      breadcrumb,
    },
  },
];
